// extracted by mini-css-extract-plugin
module.exports = {"button":"styles-module--button--1SOkS","isScrolled":"styles-module--isScrolled--nLbAY"};